import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type Result<T, E = string> =
  | { ok: true; value: T }
  | { ok: false; error: E | undefined };

export function absoluteUrl(path?: string) {
  return process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL
    ? `https://${process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}${path}`
    : `http://localhost:3000${path}`;
}

export function getS3FileUrl({
  s3Directory,
  path,
}: {
  s3Directory: string;
  path: string;
}) {
  // Clean the file path - remove leading slash and /home/scrapybara prefix if present
  let cleanPath = path;
  if (cleanPath.startsWith("/")) {
    cleanPath = cleanPath.substring(1);
  }
  if (cleanPath.startsWith("home/scrapybara/")) {
    cleanPath = cleanPath.substring("home/scrapybara/".length);
  }

  // Use hardcoded CloudFront domain
  const cloudFrontDomain = "https://d3byvqof4ma6i6.cloudfront.net";
  const cleanDomain = cloudFrontDomain
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");

  return `https://${cleanDomain}/${s3Directory}/home/scrapybara/${cleanPath}`;
}

export function getMetaKey() {
  if (typeof window !== "undefined" && window.navigator) {
    return window.navigator.platform.toLowerCase().includes("mac")
      ? "⌘"
      : "Ctrl";
  }
  return "Ctrl";
}
